import * as Yup from 'yup';
import { RECURRING_POLICY_PATTERN } from '../constants/patterns';

const contractNumberSchema = Yup.object().shape({
  policyNumber: Yup.string()
    .matches(RECURRING_POLICY_PATTERN, 'validationErrors.invalidContractNumber')
    .required('validationErrors.isRequired'),
});
export default contractNumberSchema;
